import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
// Models
import { Attachment } from 'shared/models/attachment.model';
// Services
import { NearMissStepperService } from 'shared/services/near-miss-stepper.service';

@Component({
  selector: 'gw-near-miss-step2',
  templateUrl: './near-miss-step2.component.pug',
  styleUrls: ['./near-miss-step2.component.scss']
})
export class NearMissStep2Component implements OnInit {
  descriptionForm: FormGroup;
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private nearMissStepperService: NearMissStepperService,
    private router: Router,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.initForm();
    this.changeDetector.detectChanges();
  }

  private initForm(): void {
    const stepData = this.nearMissStepperService.formSteps.step2;
    this.descriptionForm = this.formBuilder.group({
      description: [(stepData && stepData.description) || '', Validators.required],
      attachments: [(stepData && stepData.attachments) || [], ]
    });
  }

  isFieldInvalid(field: AbstractControl): boolean {
    return !field.valid && this.submitted;
  }

  updateAtachments(attachments: Array<Attachment>): void {
    this.descriptionForm.controls.attachments.setValue(attachments);
  }

  submitForm(form: FormGroup): void {
    this.submitted = true;
    if (form.valid) {
      this.updateStep(form);
      this.goToNextStep();
    }
  }

  async updateStep(form: FormGroup): Promise<void> {
    this.nearMissStepperService.formSteps.step2 = this.nearMissStepperService.convertStep2FormToObject(form);
    await this.nearMissStepperService.updateInStorage();
  }

  goToNextStep(): void {
    this.router.navigate(['/ehs/near-miss/material-damage'], { replaceUrl: true });
  }
}
